module.exports = __webpack_public_path__ + "img/4@2x.b2be34b7.png";